'use strict';

const isSmallTabletView = () => {
    const smallTabletMaxWidth = 849;
    const vpWidth = $(window).width();

    return vpWidth <= smallTabletMaxWidth;
};

module.exports = isSmallTabletView;
